<app-header></app-header>
<main>
  <div>
    <router-outlet #outlet="outlet"></router-outlet>
  </div>
  <app-footer></app-footer>
</main>
